//frontend/src/api/network.ts
import { api } from "./client";

export interface IPInfo {
  ip: string;
  country?: string;
  city?: string;
  isp?: string;
  asn?: string;
}

export const fetchPublicIP = async (): Promise<IPInfo> => {
  const res = await api.get("/admin/network/public-ip");
  return res.data;
};

export const fetchTorIP = async (): Promise<IPInfo> => {
  const res = await api.get("/admin/network/tor-ip");
  return res.data;
};